import moment from "moment-timezone";

const DATE_PART_OPTIONS: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit",
	hourCycle: "h23"
};

export function getTimeZoneOffsetMinutes(timeZone: string, date = new Date()): number {
	const momentTimeZone = moment.tz.zone(timeZone);
	if(momentTimeZone) {
		return -momentTimeZone.utcOffset(date.getTime());
	}

	return getIntlTimeZoneOffsetMinutes(timeZone, date);
}

export function formatTimeZoneOffset(
	timeZone?: string | null,
	date = new Date()
): string {
	if(!timeZone) {
		return "";
	}

	const offsetMinutes = getTimeZoneOffsetMinutes(timeZone, date);
	const sign = offsetMinutes < 0 ? "-" : "+";
	const absoluteMinutes = Math.abs(offsetMinutes);
	const hours = Math.floor(absoluteMinutes / 60).toString()
		.padStart(2, "0");
	const minutes = (absoluteMinutes % 60).toString().padStart(2, "0");

	return `UTC${sign}${hours}:${minutes}`;
}

function getIntlTimeZoneOffsetMinutes(timeZone: string, date: Date): number {
	const formatter = new Intl.DateTimeFormat("en-US", {
		...DATE_PART_OPTIONS,
		timeZone
	});
	const parts = formatter.formatToParts(date).reduce<Record<string, number>>((values, part) => {
		if(part.type !== "literal") {
			values[part.type] = Number(part.value);
		}

		return values;
	}, {});
	const hour = parts.hour === 24 ? 0 : parts.hour;
	const zonedTimeAsUtc = Date.UTC(
		parts.year,
		parts.month - 1,
		parts.day,
		hour,
		parts.minute,
		parts.second
	);
	const dateWithoutMilliseconds = date.getTime() - date.getMilliseconds();

	return Math.round((zonedTimeAsUtc - dateWithoutMilliseconds) / 60000);
}
